import styled from "styled-components";

export const MainContainer = styled.div`
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .addContactWrapper{
    margin-bottom: 70px !important;
  }
  .common__create_btn {
    background: #00a4e5;
    border-radius: 50%;
    padding: 6px;
    font-size: 10px;
    color: #fff;
    margin-left: 10px;
    &:hover {
      background-color: #0582c0;
      color: #fff;
      border: 1px solid #269bd5;
    }
  }
      .customInput {
      height: calc(2.2125rem + -5px);
    }
    .customInput:hover {
      border-color: #00a4e5;
      color: #575962;
      box-shadow: none;
    }  
  .common__icon {
    font-size: 16px;
    margin-right: 5px;
  }
  .custom__td_class {
    max-width: 200px;
  }
  .custom__td_class .common__toolTip {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .addContactWrapper {
    width: 100%;
  }
`;
